import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "do_not_wash",
  "use": "do_not_wash-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"do_not_wash\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h40v40H0z\" /><g stroke=\"currentColor\" stroke-linejoin=\"round\"><path d=\"M12.22 11.323l16.941 16.94m-16.94 0l16.94-16.94m1.77 1.614L29.095 25.37H12.285L10.45 12.937\" /><path d=\"M11.15 15.846c3.142 0 3.142 1.826 6.285 1.826 3.144 0 3.144-1.826 6.288-1.826 3.146 0 3.146 1.826 6.29 1.826\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol